/* eslint-disable react-hooks/exhaustive-deps */
import { BrandSignUpHeader } from "../SignUp/BrandSignUp";
import "./BrandWelcome.css";
import { useEffect, useState } from "react";
import { useBrand } from "../../../Providers/Brand";
import { BrandInfoCurrentSection, useAuth } from "../../../Providers/Auth";
import { toast } from "react-toastify";
import mixpanel from "mixpanel-browser";
import { useStaticData } from "@/Providers/Data";
import { useGeneralSettings } from "@/Providers/General";

import { Button } from "@/shadcnComponents/ui/button";
import { Input } from "@/shadcnComponents/ui/input";
import { Label } from "@/shadcnComponents/ui/label";
import { ArrowRight, Check, Loader2 } from "lucide-react";
// import { useCookies } from "react-cookie";
import { PhoneInput } from "@/shadcnComponents/ui/phone-input";

export interface purposeMaterDataProps {
  Registration: number;
  CompanyName: number;
  CompanyWebsite: number;
  CompanyTeamSize: number;
  companyLogo: number;
  isim: number;
  frequencyofim: number;
  expenseofim: number;
  CompanyReferralAvail: number;
  CompanyReferralShared: number;
  companyPhoneNumber: number;
  JoinedFrom: number;
}

// new design

export const BrandWelcome = () => {
  const BrandState = useBrand();
  const authState = useAuth();
  const staticDataState = useStaticData();
  const generalState = useGeneralSettings();
  const [isVisible, setIsVisible] = useState(true);
  const [displayedCredits, setDisplayedCredits] = useState(0);

  const [currentSection, setCurrentSection] =
    useState<BrandInfoCurrentSection>("Welcome");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [data, setData] = useState({
    name: "",
    designation: "",
    CompanyName: "",
    CompanyWebsite: "",
    CompanyTeamSize: "",
    JoinedFrom: "",
  });
  const [CompanyTeamSize, SetTeamSize] = useState("");
  const [JoinedFrom, SetJoinedFrom] = useState("");
  const [credits, setCredits] = useState(0);
  const [filledFields, setFilledFields] = useState([]);
  const [isim, Setisim] = useState("");
  const [purposeMaterData, setPurposeMaterData] =
    useState<purposeMaterDataProps>();

  // Phone number verification state
  const [isPhoneVerified, setIsPhoneVerified] = useState(false);

  // Animation effect for credits counter
  useEffect(() => {
    if (displayedCredits < credits) {
      // Count up when displayed value is less than target
      const timer = setTimeout(() => {
        setDisplayedCredits((prev) => Math.min(prev + 2, credits));
      }, 20);
      return () => clearTimeout(timer);
    } else if (displayedCredits > credits) {
      // Count down when displayed value is greater than target
      const timer = setTimeout(() => {
        setDisplayedCredits((prev) => Math.max(prev - 2, credits));
      }, 20);
      return () => clearTimeout(timer);
    }
  }, [displayedCredits, credits]);

  useEffect(() => {
    setCredits(authState?.loggedBrand?.credits);
    setDisplayedCredits(0); // Reset displayed credits when actual credits change
    if (authState?.loggedBrand?.currentProfileBuildingStep) {
      if (authState?.loggedBrand?.currentProfileBuildingStep === "Pricing") {
        window.open("/brand/pricing", "_self");
      } else {
        const step = authState?.loggedBrand?.currentProfileBuildingStep;
        setCurrentSection(step);
      }
    }

    // Check if phone is verified
    if (authState?.loggedBrand?.isVerified) {
      setIsPhoneVerified(true);
    }
  }, [authState]);

  useEffect(() => {
    mixpanel.track("Page visited Anchors Collab Brand Welcome Page");
    const getBrandChips = async () => {
      const response: unknown = await staticDataState.getDataFromType(
        "Brand Chips"
      );
      setPurposeMaterData(response?.[0]);
    };
    getBrandChips();
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await BrandState?.getBrandInfo();
        if (response && response.success === true) {
          // Update state with response data
          setData((prev) => ({
            ...prev,
            name: response?.data1?.name,
            designation: response?.data1?.designation,
            CompanyName: response?.data1?.CompanyName,
            CompanyWebsite: response?.data1?.CompanyWebsite,
            CompanyTeamSize: response?.data1?.CompanyTeamSize,
            JoinedFrom: response?.data1?.JoinedFrom,
          }));

          // Set team size separately
          SetTeamSize(response?.data1?.CompanyTeamSize);
          SetJoinedFrom(response?.data1?.JoinedFrom);

          // Set phone number if available
          if (response?.data1?.phoneNumber) {
            setPhoneNumber(response?.data1?.phoneNumber);
            if (response?.data1?.isVerified) {
              setIsPhoneVerified(true);
            }
          }

          // Update filledFields based on received data
          if (response?.data1) {
            const filledFieldsFromData = Object.keys(response?.data1).filter(
              (key) =>
                response?.data1[key] &&
                [
                  "name",
                  "designation",
                  "CompanyName",
                  "CompanyWebsite",
                  "CompanyTeamSize",
                  "JoinedFrom",
                  "phoneNumber",
                ]?.includes(key)
            );
            setFilledFields(filledFieldsFromData);
          }
          // Update filledFields based on received data
          if (response?.data2) {
            const filledFieldsFromData = Object.keys(response?.data2).filter(
              (key) =>
                response.data2[key] &&
                ["isim", "expenseofim", "frequencyofim"]?.includes(key) &&
                !filledFields?.includes(key)
            );
            setFilledFields((prev) => [...prev, ...filledFieldsFromData]);
          }
        }
      } catch (error) {
        console.log(error);
      }
    };
    fetchData();
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;

    if (!data[e.target.name] && purposeMaterData[name]) {
      setCredits(credits + purposeMaterData[name]);
    }

    if (data[e.target.name] && !e.target.value && purposeMaterData[name]) {
      setCredits(credits - purposeMaterData[name]);
    }

    setData((prevData) => ({
      ...prevData,
      [name]: value,
    }));

    setFilledFields((prev) => {
      if (!prev.includes(name)) {
        prev.push(name);
      }
      return prev;
    });
  };

  const handleTeamSelect = (value) => {
    if (!CompanyTeamSize) {
      setCredits(credits + purposeMaterData.CompanyTeamSize);
    }

    SetTeamSize(value);
    setFilledFields((prev) => {
      if (!prev.includes("CompanyTeamSize")) {
        prev.push("CompanyTeamSize");
      }

      return prev;
    });
  };

  const handleJoinedFromSelect = (value) => {
    if (!JoinedFrom) {
      setCredits(credits + purposeMaterData.JoinedFrom);
    }

    SetJoinedFrom(value);
    setFilledFields((prev) => {
      if (!prev.includes("joinedFrom")) {
        prev.push("joinedFrom");
      }

      return prev;
    });
  };

  const handleSubmit = async () => {
    try {
      if (!data.CompanyName) {
        return toast.error("Please Enter Company Name", {
          position: "top-center",
          autoClose: 2000,
        });
      }
      if (!data.CompanyWebsite) {
        return toast.error("Please Enter Company Website URL", {
          position: "top-center",
          autoClose: 2000,
        });
      }
      generalState?.setLoading(true);
      const result = await BrandState.UpdateBrandInfo({
        ...data,
        JoinedFrom: JoinedFrom,
        CompanyTeamSize: CompanyTeamSize,
        brandID: authState?.loggedBrand?.BrandId,
      });
      if (result.success) {
        generalState?.setLoading(false);
        mixpanel.track("Submitted Brand Welcome Page Details");
        toast.success("Details Submitted Successfully!", {
          position: "top-center",
          autoClose: 2000,
        });
        handleSectionChange("Profile2");
        authState?.setReFetchUserData((prev) => {
          return !prev;
        });
      } else {
        generalState?.setLoading(false);
        return toast.error(result.Error, {
          position: "top-center",
          autoClose: 2000,
        });
      }
    } catch (e) {
      generalState?.setLoading(false);
      return toast.error("Something went Wrong!", {
        position: "top-center",
        autoClose: 2000,
      });
    }
  };

  const handleSectionChange = async (section: BrandInfoCurrentSection) => {
    setIsVisible(false);

    await BrandState?.updateBrand({
      currentProfileBuildingStep: section,
    });
    setTimeout(() => {
      if (section === "Pricing") {
        window.open("/brand/pricing", "_self");
      }
      setCurrentSection(section);
      setIsVisible(true);
    }, 200); // Delay for transition
  };

  // Calculate completion percentage based on all form fields
  const calculateCompletion = () => {
    // Phone verification adds 1 field
    const phoneFieldCount = 1;
    const phoneFilledCount = isPhoneVerified ? 1 : phoneNumber ? 0.5 : 0;

    // Fields from Welcome section
    const welcomeFieldCount = isim === "No" ? 7 : 9; // name, designation, company name, website, team size, joined from
    const welcomeFilledCount =
      isim === "No"
        ? filledFields?.filter(
            (item) => item !== "expenseofim" && item !== "frequencyofim"
          )?.length
        : filledFields.length;

    // Total fields and filled fields
    const totalFields = welcomeFieldCount + phoneFieldCount;
    const completedFields = welcomeFilledCount + phoneFilledCount;

    return Math.round((completedFields / totalFields) * 100);
  };

  return (
    <div className="min-h-screen">
      <BrandSignUpHeader logout />
      <div className="grid min-h-[calc(100vh-4rem)] grid-cols-1 lg:grid-cols-2">
        <div className="hidden lg:block">
          <div className="flex h-full flex-col justify-center items-center bg-muted p-10">
            <div className="max-w-md space-y-8">
              <div>
                <h3 className="text-3xl font-bold">
                  Complete your brand profile
                </h3>
                <p className="mt-2 text-lg text-muted-foreground">
                  Help us understand your brand better to match you with the
                  perfect influencers
                </p>
              </div>

              <div className="rounded-xl bg-background p-6 shadow-sm">
                <div className="flex items-center justify-between">
                  <div>
                    <h3 className="text-lg font-semibold">anchors Credits</h3>
                    <div className="mt-1 text-4xl font-bold text-primary tabular-nums">
                      {displayedCredits}
                    </div>
                  </div>
                  <div className="h-16 w-16 rounded-full bg-primary/20 p-4">
                    <div className="h-full w-full rounded-full bg-primary animate-pulse" />
                  </div>
                </div>
                <div className="mt-4 space-y-4">
                  <div className="space-y-2">
                    <div className="flex justify-between text-sm">
                      <span>Profile Completion</span>
                      <span>{calculateCompletion()}%</span>
                    </div>
                    <div className="h-2 rounded-full bg-muted">
                      <div
                        className="h-full rounded-full bg-primary transition-all duration-500"
                        style={{ width: `${calculateCompletion()}%` }}
                      />
                    </div>
                  </div>
                  <p className="text-sm text-muted-foreground">
                    Complete your profile to earn more credits which can be
                    redeemed during payment
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="flex items-center justify-center bg-dot-pattern p-6">
          <div
            className={`w-full max-w-sm transition-opacity duration-200 ${
              isVisible ? "opacity-100" : "opacity-0"
            }`}
          >
            {currentSection === "Welcome" && (
              <div className="space-y-8">
                <div className="space-y-2">
                  <h1 className="text-2xl font-bold tracking-tighter">
                    Tell us about your brand
                  </h1>
                  <p className="text-sm text-muted-foreground">
                    Complete each field to earn credits and unlock platform
                    features
                  </p>
                </div>

                <div className="space-y-6">
                  <div className="space-y-2">
                    <Label htmlFor="name">Your Full Name</Label>
                    <Input
                      id="name"
                      name="name"
                      value={data.name}
                      onChange={handleChange}
                      placeholder="Ravi Ahirwar"
                      className="border-primary/20 focus:border-primary"
                    />
                  </div>

                  {filledFields.includes("name") && (
                    <div className="space-y-2">
                      <Label htmlFor="designation">Designation</Label>
                      <Input
                        id="designation"
                        name="designation"
                        value={data.designation}
                        onChange={handleChange}
                        placeholder="Marketing Manager"
                        className="border-primary/20 focus:border-primary"
                      />
                    </div>
                  )}

                  {filledFields.includes("designation") && (
                    <div className="space-y-2">
                      <Label htmlFor="CompanyName">Company Name*</Label>
                      <Input
                        id="CompanyName"
                        name="CompanyName"
                        value={data.CompanyName}
                        onChange={handleChange}
                        placeholder="Boat"
                        className="border-primary/20 focus:border-primary"
                      />
                    </div>
                  )}

                  {filledFields.includes("CompanyName") && (
                    <div className="space-y-2">
                      <Label htmlFor="CompanyWebsite">Website URL*</Label>
                      <Input
                        id="CompanyWebsite"
                        name="CompanyWebsite"
                        value={data.CompanyWebsite}
                        onChange={handleChange}
                        placeholder="www.boatindia.com"
                        className="border-primary/20 focus:border-primary"
                      />
                    </div>
                  )}

                  {filledFields.includes("CompanyWebsite") && (
                    <div className="space-y-2">
                      <Label>Company Size</Label>
                      <div className="grid grid-cols-2 gap-2">
                        <Button
                          type="button"
                          variant={
                            CompanyTeamSize === "1-10" ? "default" : "outline"
                          }
                          className="w-full justify-start"
                          onClick={() => handleTeamSelect("1-10")}
                        >
                          {CompanyTeamSize === "1-10" && (
                            <Check className="mr-2 h-4 w-4" />
                          )}
                          1-10
                        </Button>
                        <Button
                          type="button"
                          variant={
                            CompanyTeamSize === "11-50" ? "default" : "outline"
                          }
                          className="w-full justify-start"
                          onClick={() => handleTeamSelect("11-50")}
                        >
                          {CompanyTeamSize === "11-50" && (
                            <Check className="mr-2 h-4 w-4" />
                          )}
                          11-50
                        </Button>
                        <Button
                          type="button"
                          variant={
                            CompanyTeamSize === "51-100" ? "default" : "outline"
                          }
                          className="w-full justify-start"
                          onClick={() => handleTeamSelect("51-100")}
                        >
                          {CompanyTeamSize === "51-100" && (
                            <Check className="mr-2 h-4 w-4" />
                          )}
                          51-100
                        </Button>
                        <Button
                          type="button"
                          variant={
                            CompanyTeamSize === "101-200"
                              ? "default"
                              : "outline"
                          }
                          className="w-full justify-start"
                          onClick={() => handleTeamSelect("101-200")}
                        >
                          {CompanyTeamSize === "101-200" && (
                            <Check className="mr-2 h-4 w-4" />
                          )}
                          101-200
                        </Button>
                        <Button
                          type="button"
                          variant={
                            CompanyTeamSize === ">200" ? "default" : "outline"
                          }
                          className="w-full justify-start col-span-2"
                          onClick={() => handleTeamSelect(">200")}
                        >
                          {CompanyTeamSize === ">200" && (
                            <Check className="mr-2 h-4 w-4" />
                          )}
                          More than 200
                        </Button>
                      </div>
                    </div>
                  )}

                  {filledFields.includes("CompanyTeamSize") && (
                    <div className="space-y-2">
                      <Label>How did you hear about us?</Label>
                      <div className="grid grid-cols-2 gap-2">
                        <Button
                          type="button"
                          variant={
                            JoinedFrom === "From Creator"
                              ? "default"
                              : "outline"
                          }
                          className="w-full justify-start"
                          onClick={() => handleJoinedFromSelect("From Creator")}
                        >
                          {JoinedFrom === "From Creator" && (
                            <Check className="mr-2 h-4 w-4" />
                          )}
                          From Creator
                        </Button>
                        <Button
                          type="button"
                          variant={
                            JoinedFrom === "From Friend" ? "default" : "outline"
                          }
                          className="w-full justify-start"
                          onClick={() => handleJoinedFromSelect("From Friend")}
                        >
                          {JoinedFrom === "From Friend" && (
                            <Check className="mr-2 h-4 w-4" />
                          )}
                          From Friend
                        </Button>
                        <Button
                          type="button"
                          variant={
                            JoinedFrom === "Google" ? "default" : "outline"
                          }
                          className="w-full justify-start"
                          onClick={() => handleJoinedFromSelect("Google")}
                        >
                          {JoinedFrom === "Google" && (
                            <Check className="mr-2 h-4 w-4" />
                          )}
                          Google
                        </Button>
                        <Button
                          type="button"
                          variant={
                            JoinedFrom === "WhatsApp groups"
                              ? "default"
                              : "outline"
                          }
                          className="w-full justify-start"
                          onClick={() =>
                            handleJoinedFromSelect("WhatsApp groups")
                          }
                        >
                          {JoinedFrom === "WhatsApp groups" && (
                            <Check className="mr-2 h-4 w-4" />
                          )}
                          WhatsApp groups
                        </Button>
                        <Button
                          type="button"
                          variant={
                            JoinedFrom === "Productathon"
                              ? "default"
                              : "outline"
                          }
                          className="w-full justify-start"
                          onClick={() => handleJoinedFromSelect("Productathon")}
                        >
                          {JoinedFrom === "Productathon" && (
                            <Check className="mr-2 h-4 w-4" />
                          )}
                          Productathon
                        </Button>
                        <Button
                          type="button"
                          variant={
                            JoinedFrom === "APPSUMO" ? "default" : "outline"
                          }
                          className="w-full justify-start"
                          onClick={() => handleJoinedFromSelect("APPSUMO")}
                        >
                          {JoinedFrom === "APPSUMO" && (
                            <Check className="mr-2 h-4 w-4" />
                          )}
                          APPSUMO
                        </Button>
                      </div>
                    </div>
                  )}

                  {filledFields.includes("joinedFrom") && (
                    <Button
                      className="w-full bg-red-500 hover:bg-red-400 "
                      onClick={handleSubmit}
                    >
                      Save & Continue
                    </Button>
                  )}
                </div>
              </div>
            )}

            {currentSection === "Profile2" && (
              <BrandProfile2ModernUI
                onSubmit={() => {
                  handleSectionChange("Contact");
                }}
                initialCredits={credits}
                onCreditsChange={setCredits}
                filledFields={filledFields}
                setFilledFields={setFilledFields}
                isim={isim}
                Setisim={Setisim}
              />
            )}

            {currentSection === "Contact" && (
              <MobileVerification
                onSubmit={() => {
                  handleSectionChange("Pricing");
                }}
                phoneNumber={phoneNumber}
                setPhoneNumber={setPhoneNumber}
                onVerification={(isVerified) => {
                  setIsPhoneVerified(isVerified);
                  // Add credits for phone verification
                  if (isVerified && purposeMaterData?.companyPhoneNumber) {
                    setCredits(credits + purposeMaterData.companyPhoneNumber);
                  }
                }}
                purposeMaterData={purposeMaterData}
              />
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

// Modernized version of BrandProfile2
interface BrandProfile2ModernUIProps {
  onSubmit: () => void;
  initialCredits: number;
  onCreditsChange: (credits: number) => void;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  filledFields: any[];
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  setFilledFields: React.Dispatch<React.SetStateAction<any[]>>;
  isim: string;
  Setisim: React.Dispatch<React.SetStateAction<string>>;
}

const BrandProfile2ModernUI = ({
  onSubmit,
  initialCredits,
  onCreditsChange,
  filledFields,
  setFilledFields,
  isim,
  Setisim,
}: BrandProfile2ModernUIProps) => {
  const BrandState = useBrand();
  const authState = useAuth();
  const staticDataState = useStaticData();
  const generalState = useGeneralSettings();

  const [isimCredit, setisimCredit] = useState(0);
  const [frequencyofim, Setfrequencyofim] = useState("");
  const [frequencyofimCredit, setfrequencyofimCredit] = useState(0);
  const [expenseofim, Setexpenseofim] = useState("");
  const [expenseofimCredit, setexpenseofimCredit] = useState(0);
  const [credits, setCredits] = useState(initialCredits || 0);
  const [purposeMaterData, setPurposeMaterData] =
    useState<purposeMaterDataProps>();
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    authState?.setReFetchBrandData((prev: any) => {
      !prev;
    });
    setCredits(authState?.loggedBrand?.credits || initialCredits);
    onCreditsChange(authState?.loggedBrand?.credits || initialCredits);
  }, []);

  useEffect(() => {
    mixpanel.track("Page visited Anchors Collab Brand Profile2");
    setCredits(authState?.loggedBrand?.credits || initialCredits);
    onCreditsChange(authState?.loggedBrand?.credits || initialCredits);
    const getBrandChips = async () => {
      const response: unknown = await staticDataState.getDataFromType(
        "Brand Chips"
      );
      setPurposeMaterData(response?.[0]);
    };
    getBrandChips();
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await BrandState?.getBrandInfo();
        if (response && response.success === true) {
          // Update state with response data
          if (response?.data2?.isim) {
            Setisim(response?.data2?.isim ?? "");
            setisimCredit(purposeMaterData?.isim);
          }
          if (response?.data2?.expenseofim) {
            Setexpenseofim(response?.data2?.expenseofim ?? "");
            setexpenseofimCredit(purposeMaterData?.expenseofim);
          }
          if (response?.data2?.frequencyofim) {
            Setfrequencyofim(response?.data2?.frequencyofim ?? "");
            setfrequencyofimCredit(purposeMaterData?.frequencyofim);
          }
        }
      } catch (error) {
        console.log(error);
      }
    };
    fetchData();
  }, []);
  console.log({ isimCredit, expenseofimCredit, frequencyofimCredit, credits });
  const handleisimSelect = (value) => {
    if (value === "No") {
      if (!isimCredit) {
        setisimCredit(purposeMaterData?.isim);
        setCredits(authState?.loggedBrand?.credits + purposeMaterData?.isim);
        onCreditsChange(
          authState?.loggedBrand?.credits + purposeMaterData?.isim
        );
      } else {
        setCredits(credits - expenseofimCredit - frequencyofimCredit);
        onCreditsChange(credits - expenseofimCredit - frequencyofimCredit);
      }
    }
    if (value === "Yes") {
      if (!isimCredit) {
        setisimCredit(purposeMaterData?.isim);
        setCredits(credits + 10);
        onCreditsChange(credits + 10);
      } else if (isim === "No") {
        setCredits(credits + expenseofimCredit + frequencyofimCredit);
        onCreditsChange(credits + expenseofimCredit + frequencyofimCredit);
      }
    }

    Setisim(value);
    setFilledFields((prev) => {
      if (!prev.includes("isim")) {
        prev.push("isim");
      }
      return prev;
    });
  };

  const handlefrequencyofimSelect = (value) => {
    if (!frequencyofimCredit) {
      setfrequencyofimCredit(purposeMaterData?.frequencyofim);
      setCredits(credits + purposeMaterData?.frequencyofim);
      onCreditsChange(credits + purposeMaterData?.frequencyofim);
    }

    Setfrequencyofim(value);
    setFilledFields((prev) => {
      if (!prev.includes("frequencyofim")) {
        prev.push("frequencyofim");
      }
      return prev;
    });
  };

  const handleexpenseofimSelect = (value) => {
    if (!expenseofimCredit) {
      setexpenseofimCredit(purposeMaterData?.expenseofim);
      setCredits(credits + purposeMaterData?.expenseofim);
      onCreditsChange(credits + purposeMaterData?.expenseofim);
    }

    Setexpenseofim(value);
    setFilledFields((prev) => {
      if (!prev.includes("expenseofim")) {
        prev.push("expenseofim");
      }
      return prev;
    });
  };

  const handleSubmit = async () => {
    try {
      setIsLoading(true);
      generalState?.setLoading(true);
      const result = await BrandState.UpdateBrandMarketingInfo({
        isim: isim,
        frequencyofim: isim !== "No" ? frequencyofim : "",
        expenseofim: isim !== "No" ? expenseofim : "",
        brandID: authState?.loggedBrand?.BrandId,
      });
      if (result.success) {
        generalState?.setLoading(false);
        setIsLoading(false);
        mixpanel.track("Submitted Brand Profile2 Details");
        toast.success("Details Submitted Successfully!", {
          position: "top-center",
          autoClose: 2000,
        });
        authState?.setReFetchBrandData((prev) => {
          return !prev;
        });
        onSubmit?.();
      } else {
        generalState?.setLoading(false);
        setIsLoading(false);
        return toast.error(result.Error, {
          position: "top-center",
          autoClose: 2000,
        });
      }
    } catch (e) {
      generalState?.setLoading(false);
      setIsLoading(false);
      return toast.error("Something went Wrong!", {
        position: "top-center",
        autoClose: 2000,
      });
    }
  };

  return (
    <div className="space-y-8">
      <div className="space-y-2">
        <h1 className="text-2xl font-bold tracking-tighter">
          Let’s Get to Know You
        </h1>
        <p className="text-sm text-muted-foreground">
          A few quick details to make your experience smoother and more relevant
        </p>
      </div>

      <div className="space-y-6">
        <div className="space-y-2">
          <Label>Previous influencer marketing experience?</Label>
          <div className="grid grid-cols-2 gap-2">
            <Button
              type="button"
              variant={isim === "Yes" ? "default" : "outline"}
              className="w-full justify-center"
              onClick={() => handleisimSelect("Yes")}
            >
              {isim === "Yes" && <Check className="mr-2 h-4 w-4" />}
              Yes
            </Button>
            <Button
              type="button"
              variant={isim === "No" ? "default" : "outline"}
              className="w-full justify-center"
              onClick={() => handleisimSelect("No")}
            >
              {isim === "No" && <Check className="mr-2 h-4 w-4" />}
              No
            </Button>
          </div>
        </div>

        {isim === "Yes" && (
          <div className="space-y-2">
            <Label>Average no. of campaigns in a month?</Label>
            <div className="grid grid-cols-3 gap-2">
              <Button
                type="button"
                variant={frequencyofim === "1-5" ? "default" : "outline"}
                className="w-full justify-center"
                onClick={() => handlefrequencyofimSelect("1-5")}
              >
                {frequencyofim === "1-5" && <Check className="mr-2 h-4 w-4" />}
                1-5
              </Button>
              <Button
                type="button"
                variant={frequencyofim === "5-10" ? "default" : "outline"}
                className="w-full justify-center"
                onClick={() => handlefrequencyofimSelect("5-10")}
              >
                {frequencyofim === "5-10" && <Check className="mr-2 h-4 w-4" />}
                5-10
              </Button>
              <Button
                type="button"
                variant={frequencyofim === ">10" ? "default" : "outline"}
                className="w-full justify-center"
                onClick={() => handlefrequencyofimSelect(">10")}
              >
                {frequencyofim === ">10" && <Check className="mr-2 h-4 w-4" />}
                {">10"}
              </Button>
            </div>
          </div>
        )}

        {isim === "Yes" && filledFields.includes("frequencyofim") && (
          <div className="space-y-2">
            <Label>Monthly influencer marketing Budget?</Label>
            <div className="grid grid-cols-2 gap-2">
              <Button
                type="button"
                variant={expenseofim === "1-10k" ? "default" : "outline"}
                className="w-full justify-center"
                onClick={() => handleexpenseofimSelect("1-10k")}
              >
                {expenseofim === "1-10k" && <Check className="mr-2 h-4 w-4" />}
                1-10K
              </Button>
              <Button
                type="button"
                variant={expenseofim === "10k-50k" ? "default" : "outline"}
                className="w-full justify-center"
                onClick={() => handleexpenseofimSelect("10k-50k")}
              >
                {expenseofim === "10k-50k" && (
                  <Check className="mr-2 h-4 w-4" />
                )}
                10K-50K
              </Button>
              <Button
                type="button"
                variant={expenseofim === "50k-100k" ? "default" : "outline"}
                className="w-full justify-center"
                onClick={() => handleexpenseofimSelect("50k-100k")}
              >
                {expenseofim === "50k-100k" && (
                  <Check className="mr-2 h-4 w-4" />
                )}
                50K-1L
              </Button>
              <Button
                type="button"
                variant={expenseofim === ">100k" ? "default" : "outline"}
                className="w-full justify-center"
                onClick={() => handleexpenseofimSelect(">100k")}
              >
                {expenseofim === ">100k" && <Check className="mr-2 h-4 w-4" />}
                {">1L"}
              </Button>
            </div>
          </div>
        )}

        {(isim === "No" ||
          (isim === "Yes" && filledFields.includes("expenseofim"))) && (
          <Button
            className="w-full bg-red-500 hover:bg-red-400"
            onClick={handleSubmit}
            disabled={isLoading}
          >
            {isLoading ? (
              <>
                <Loader2 className="mr-2 h-4 w-4 animate-spin " />
                Saving...
              </>
            ) : (
              "Continue"
            )}
          </Button>
        )}
      </div>
    </div>
  );
};

interface MobileVerificationProps {
  onSubmit?: () => void;
  phoneNumber: string;
  setPhoneNumber: React.Dispatch<React.SetStateAction<string>>;
  onVerification;
  purposeMaterData: purposeMaterDataProps;
}

// Frontend: Updated MobileVerification Component

export function MobileVerification({
  onSubmit,
  phoneNumber,
  setPhoneNumber,
}: MobileVerificationProps) {
  const [isLoading, setIsLoading] = useState(false);
  const [showOTP, setShowOTP] = useState(false);
  const [countdown, setCountdown] = useState(0);
  const [otp, setOtp] = useState("");
  const [remainingAttempts, setRemainingAttempts] = useState(3);

  const BrandState = useBrand();
  const authState = useAuth();

  // Updated send OTP function
  const handleSendOTP = async () => {
    try {
      setIsLoading(true);

      if (!phoneNumber) {
        setIsLoading(false);
        return toast.error("Please fill in Mobile number.", {
          autoClose: 1500,
        });
      }

      // Basic phone validation (more validation on server)
      if (phoneNumber.length < 10) {
        setIsLoading(false);
        return toast.error("Enter a proper mobile number", {
          autoClose: 1500,
        });
      }

      // Save contact number first
      const saveResult = await BrandState?.SaveContactNumber(phoneNumber);
      if (!saveResult.success) {
        setIsLoading(false);
        return toast.error(
          saveResult?.error || "Failed to save contact number",
          {
            autoClose: 1500,
          }
        );
      }

      // Send OTP via secure endpoint
      const otpResult = await BrandState?.SendSecureOTP(phoneNumber);

      if (otpResult?.success) {
        toast.success("OTP sent successfully", {
          autoClose: 1500,
        });

        authState?.setReFetchUserData((prev) => !prev);
        setShowOTP(true);
        setCountdown(120); // 2 minutes countdown
        setRemainingAttempts(3);

        // Start countdown timer
        const timer = setInterval(() => {
          setCountdown((prev) => {
            if (prev <= 1) {
              clearInterval(timer);
              return 0;
            }
            return prev - 1;
          });
        }, 1000);
      } else {
        toast.error(otpResult?.error || "Failed to send OTP", {
          autoClose: 1500,
        });
      }

      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
      console.error("Send OTP error:", error);
      toast.error("Something went wrong! Please try again.", {
        position: "top-center",
        autoClose: 2000,
      });
    }
  };

  // Updated verify OTP function
  const handleVerifyOTP = async () => {
    try {
      mixpanel.track("Verify otp anchors collab");

      if (otp?.length !== 6) {
        return toast.info("Enter a 6-digit OTP", {
          position: "top-center",
          autoClose: 2000,
        });
      }

      setIsLoading(true);

      // Verify OTP via secure server endpoint
      const result = await BrandState?.VerifySecureOTP(otp, phoneNumber);

      if (result?.success) {
        toast.success("Verification successful!", {
          position: "top-center",
          autoClose: 2000,
        });

        authState?.setReFetchUserData((prev) => !prev);
        onSubmit?.();
      } else {
        // Handle remaining attempts
        if (result?.remainingAttempts !== undefined) {
          setRemainingAttempts(result.remainingAttempts);
        }

        toast.error(result?.error || "Invalid OTP", {
          position: "top-center",
          autoClose: 2000,
        });

        // Clear OTP input if no attempts remaining
        if (result?.remainingAttempts === 0) {
          setShowOTP(false);
          setOtp("");
        }
      }

      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
      console.error("Verify OTP error:", error);
      toast.error("Verification failed! Please try again.", {
        position: "top-center",
        autoClose: 2000,
      });
    }
  };

  // Resend OTP function
  const handleResendOTP = async () => {
    setOtp("");
    setCountdown(0);
    await handleSendOTP();
  };

  return (
    <div className="mx-auto w-full max-w-sm space-y-6">
      <div className="space-y-2">
        <h1 className="text-2xl font-bold tracking-tighter">
          Verify your mobile number
        </h1>
        <p className="text-sm text-muted-foreground">
          Add your mobile number to complete your profile and earn additional
          credits
        </p>
      </div>

      {!showOTP ? (
        <div className="space-y-4">
          <div className="space-y-2">
            <Label htmlFor="mobile">Mobile Number</Label>
            <div className="relative">
              <PhoneInput
                style={{ width: "100%" }}
                name="mobile"
                value={phoneNumber}
                onChange={(e) => setPhoneNumber(e)}
                placeholder="8799710137"
                defaultCountry="IN"
              />
            </div>
          </div>
          <Button
            onClick={handleSendOTP}
            className="w-full bg-red-500 hover:bg-red-400"
            disabled={isLoading}
          >
            {isLoading ? (
              <Loader2 className="mr-2 h-4 w-4 animate-spin" />
            ) : (
              <>
                Send OTP
                <ArrowRight className="ml-2 h-4 w-4" />
              </>
            )}
          </Button>
        </div>
      ) : (
        <div className="space-y-4">
          <div className="rounded-lg bg-muted p-4">
            <div className="flex items-center justify-between">
              <span className="text-sm">{phoneNumber}</span>
              <Button
                variant="ghost"
                size="sm"
                onClick={() => {
                  setShowOTP(false);
                  setOtp("");
                  setCountdown(0);
                }}
                className="h-auto p-0 text-primary hover:text-primary/90"
              >
                Change
              </Button>
            </div>
          </div>

          <div className="space-y-4">
            <div className="space-y-2">
              <Label htmlFor="otp">Enter OTP</Label>
              <Input
                value={otp}
                id="otp"
                type="text"
                required
                maxLength={6}
                className="text-center text-lg tracking-widest"
                onChange={(e) => setOtp(e.target.value.replace(/\D/g, ""))} // Only numbers
                placeholder="123456"
              />
              {remainingAttempts < 3 && (
                <p className="text-sm text-orange-600">
                  {remainingAttempts} attempt(s) remaining
                </p>
              )}
            </div>

            <Button
              onClick={handleVerifyOTP}
              className="w-full bg-red-500 hover:bg-red-400"
              disabled={isLoading || otp.length !== 6}
            >
              {isLoading ? (
                <>
                  <Loader2 className="mr-2 h-4 w-4 animate-spin" />
                  Verifying...
                </>
              ) : (
                "Verify & Continue"
              )}
            </Button>

            {countdown > 0 ? (
              <p className="text-center text-sm text-muted-foreground">
                Resend OTP in {Math.floor(countdown / 60)}:
                {(countdown % 60).toString().padStart(2, "0")}
              </p>
            ) : (
              <Button
                type="button"
                variant="link"
                className="w-full text-sm"
                onClick={handleResendOTP}
                disabled={isLoading}
              >
                Resend OTP
              </Button>
            )}
          </div>
        </div>
      )}
    </div>
  );
}
